<!--
PARA QUE ESTE COMPONENTE FUNCIONE BIEN, TENEMOS 
QUE IMPLEMENTAR LOS SIGUIENTES METODOS EN EL PADRE:

cambioBusiness(idBusinessData, listTpv) {},
emitirConsulta() {},
cambioTpv(idTpvData) {},
cambioHora(dates) {},
cambiarExtra(idExtraElement){}, //SOLO SI conBuscador=true

-->
<template>
  <div class="col-md-12">
    <div class="card">
      <div class="row">
        <div class="col-md-2" v-if="sectores">
          <div class="form-group">
            <label for="listSectores">{{ 'Sector' }}</label>
            <el-select class="select-default" size="large" v-model="idSectorData" filterable @change="cambioSector()"
              :placeholder="'Selecciona un sector'">
              <el-option v-for="(sector, index) in listSectores" class="select-primary" :value="sector.id"
                :label="sector.name" :key="index">
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="col-md-2" v-if="idCompany != 0">
          <div class="form-group">
            <label for="listCompanies">{{ 'Empresa' }}</label>
            <el-select 
            class="select-default" size="large" v-model="idCompanyData" filterable @change="cambioCompany()"
              :placeholder="'Selecciona una empresa'">
              <el-option v-for="(company, index) in listCompanies" class="select-primary" :value="company.id"
                :label="company.fiscalName" :key="index">
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="col-md-2">
          <div class="form-group" v-if="sectores == false">
            <label for="listBusiness">{{ $t("negocio") }}</label>
            <el-select class="select-default" size="large" v-model="idBusinessData" filterable
              @change="cambioBusiness()" :placeholder="$t('seleccionaNegocio')">
              <el-option v-for="(business, index) in listBusinesses" class="select-primary" :value="business.id"
                :label="business.establishmentName" :key="index">
              </el-option>
            </el-select>
          </div>
          <div v-else>
            <label for="listBusiness">{{ $t("negocio") }}</label>
            <el-select class="select-default" size="large" v-model="idBusinessData" filterable
              @change="cambioBusiness()" :placeholder="$t('seleccionaNegocio')">
              <el-option class="select-primary" :value="-1" :label="'Todos'">
              </el-option>
              <el-option v-for="(business, index) in listBusinesses" class="select-primary" :value="business.id"
                :label="business.establishmentName" :key="index">
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="col-md-3 col-sm-2">
          <div class="form-group">
            <label for="listTPV">{{ $t("TPV") }}</label>
            <div class="row">
              <div class="col-8" v-if="conTodos == false">
                <el-select class="select-default" size="large" v-model="idTpvData" filterable @change="cambioTpv()"
                  placeholder="SeleccionaTPV" :disabled="idBusinessData == -1 && !sectores">
                  <el-option v-for="tpv in listTpv" class="select-primary" :value="tpv.id" :label="tpv.nameShow"
                    :key="tpv.id">
                  </el-option>
                </el-select>
              </div>
              <div class="col-8" v-else>
                <el-select class="select-default" size="large" v-model="idTpvData" filterable @change="cambioTpv()"
                  placeholder="SeleccionaTPV" :disabled="idBusinessData == -1 && !sectores">
                  <el-option class="select-primary" :value="-1" :label="'Todos'">
                  </el-option>
                  <el-option v-for="tpv in listTpv" class="select-primary" :value="tpv.id" :label="tpv.nameShow"
                    :key="tpv.id">
                  </el-option>
                </el-select>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-2" v-if="conBuscador">
          <div class="form-group">
            <div class="row">
              <div class="col-md-10">
                <div class="form-group">
                  <label for="productos">{{
                    textoExtra.charAt(0).toUpperCase() + textoExtra.slice(1)
                  }}</label>
                  <el-select class="select-default" size="large" v-model="idExtraElement" filterable remote
                    data-is-search="true" :placeholder="textoExtraPlaceholder" @change="emitirConsulta()"
                    :remote-method="search">
                    <el-option v-for="p in listExtraElement" class="select-primary" :value="p.id"
                      :label="p.active == '1' ? p.name : p.name + ' [' + $t('BAJA') + ']'" :key="p.id">
                    </el-option>
                  </el-select>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-------------------------------------------------------------------------------------------------------->
        <div class="col-md-2" v-if="conBuscadorRepartidor">
          <div class="form-group">
            <div class="row">
              <div class="col-md-10">
                <div class="form-group">
                  <label for="repartidor">{{
                    textoExtra.charAt(0).toUpperCase() + textoExtra.slice(1)
                  }}</label>
                  <!-- remote  :remote-method="search" -->
                    <el-select class="select-default" filterable  size="large" v-model="idRepartidorData" 
                      :placeholder="textoExtraPlaceholder" @change="emitirConsulta()" >

                      <el-option v-for="(worker, index) in nombresRepartidores" :key="worker.id" :value="worker.name" :label="worker.name" @click="handleWorkerSelect(worker)" />
                    </el-select>
                  
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-------------------------------------------------------------------------------------------------------->
        <div v-if="!quitarFechas" class="col-md-3">
          <div class="row">
            <div class="col-md-6">
              <div class="form-group">
                <label>{{ $t("fechaInicio") }}</label>

                <datetime :value-zone="timezoneId" :auto="true" class="theme-numier" format="dd-MM-yyyy"
                  @input="cambioHora()" :title="$t('fechaInicio')" :phrases="{ ok: $t('aceptar'), cancel: $t('salir') }"
                  input-class="form-control" v-model="dates[0]"></datetime>

              </div>
              <div v-if="busquedaPorHoras" class="form-group">
                <label>{{ $t("horaInicio") }}</label>
                <datetime :value-zone="timezoneId" :auto="true" class="theme-numier" type="time"
                  @change="cambioHorasBusqueda()" :title="$t('horarioInicio')"
                  :phrases="{ ok: $t('aceptar'), cancel: $t('salir') }" input-class="form-control" format="HH:mm"
                  v-model="hoursdesde">
                </datetime>
              </div>
            </div>
            <div class="col-md-6">

              <div class="form-group">
                <label>{{ $t("fechaFin") }}</label>
                <datetime :value-zone="timezoneId" :auto="true" class="theme-numier" :title="$t('fechaFin')"
                  format="dd-MM-yyyy" @input="cambioHora()" :phrases="{ ok: $t('aceptar'), cancel: $t('salir') }"
                  input-class="form-control" v-model="dates[1]"></datetime>
              </div>


              <div v-if="busquedaPorHoras" class="form-group">
                <label>{{ $t("horaFin") }}</label>
                <datetime :value-zone="timezoneId" :auto="true" type="time" class="theme-numier" :title="$t('horaFin')"
                  :phrases="{ ok: $t('aceptar'), cancel: $t('salir') }" @change="cambioHorasBusqueda()"
                  input-class="form-control" format="HH:mm" v-model="hourshasta">
                </datetime>
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-2" style="margin-top: 10px" v-if="conBusquedaPorHoras">
          <label> </label><br>
          <div class="form-group">
            <el-checkbox v-model="busquedaPorHoras" @change="cambioBuscarPorHoras()">
              <strong>{{ $t("buscarPorHoras") }}</strong>
            </el-checkbox>
          </div>
        </div>
        <div class="col-md-1" v-if="!quitarConsultas && !sectores">
          <label data-v-07553382="">&nbsp;</label>
          <div class="form-group" style="text-align: center;">
            <button v-if="!gStock" class="btn btn-primary" @click="emitirConsulta()">
              <i class="fa fa-refresh"></i>{{ $t("consultar") }}
            </button>
            <button v-else class="btn btn-primary" @click="emitirConsulta()">
              <i class="fa fa-upload"></i> {{ $t("exportar") }}
            </button>
            <el-checkbox v-if="conFiltrarPorFecha" v-model="filtrarPorFecha">{{ $t("filtrarPorFecha") }}
              <i v-tooltip.top-center="'Si esta opción está activada, filtrará por dias naturales, no por fecha de apertura de caja.'
                " class="fa fa-info-circle"></i></el-checkbox>
          </div>
        </div>
        <div :class="quitarFechas ? 'col-md-5 col-3' : 'col-md-12 col-3'" v-else-if="!quitarConsultas && sectores">
          <label data-v-07553382="">&nbsp;</label>
          <div class="form-group" style="text-align: right; margin-right: 9%;">
            <button class="btn btn-primary" @click="emitirConsulta()">
              <i class="fa fa-refresh"></i>{{ $t("consultar") }}
            </button>
            <el-checkbox v-if="conFiltrarPorFecha" v-model="filtrarPorFecha">{{ $t("filtrarPorFecha") }}
              <i v-tooltip.top-center="'Si esta opción está activada, filtrará por dias naturales, no por fecha de apertura de caja.'
                " class="fa fa-info-circle"></i></el-checkbox>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  DatePicker,
  Select,
  Option,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  Button,
  Checkbox,
  CheckboxGroup,
  Loading
} from "element-ui";
import moment from "moment";

export default {
  props: {
    listBusinesses: Array,
    listTpv: Array,
    listSectores: Array,
    listworkers: Array,
    nombresRepartidores: {
      type: Array,
      required: false
    },
    listCompanies: Array,
    idBusiness: [Number, String],
    idTpv: [Number, String],
    idSector: [Number, String],
    idCompany: { default: 0 },
    dateto: [Date, String],
    datefrom: [Date, String],
    hoursto: [String],
    hoursfrom: [String],
    quitarFechas: { default: false },
    quitarConsultas: { default: false },
    gStock: { default: false },
    conTodos: { default: false },
    conFiltrarPorFecha: { default: false },
    conBuscador: { default: false },
    /**---------------------------------------- */
    conBuscadorRepartidor: { default: false },
    /**---------------------------------------- */
    necesarioBuscador: { default: true },
    conBusquedaPorHoras: { default: false },
    sectores: { default: false },
    textoExtra: [String],
    textoExtraPlaceholder: [String],
    listElmExtra: Array,
  },

  data() {
    return {
      idRepartidorData: null,
      list: [],
      listNameWorkers: [],
      /*
      workers: {
        id: ,
        name: 
      }
      */

      
      dates: [this.datefrom, this.dateto],
      hoursdesde: this.hoursfrom,
      hourshasta: this.hoursto,
      idBusinessData: 0,
      idCompanyData: 0,
      idSectorData: this.listSectores && this.listSectores[0].id ? this.listSectores[0].id : -1,
      idTpvData: -1,
      listTpvData: [],
      listBusinessData: [],
      filtrarPorFecha: false,
      idExtraElement: 0,
      listExtraElement: this.listElmExtra,
      busquedaPorHoras: false,
      cargaInicial: false,
    };
  },

  components: {
    [DatePicker.name]: DatePicker,
    [Select.name]: Select,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    [Button.name]: Button,
    [Option.name]: Option,
    [Checkbox.name]: Checkbox,
    [CheckboxGroup.name]: CheckboxGroup,
  },
  computed: {
    timezoneId() {
      return Intl.DateTimeFormat().resolvedOptions().timeZone;
    }
  },
  beforeUpdate() {
    this.idBusinessData = this.idBusiness;
    this.idCompanyData = this.idCompany;
    this.idTpvData = this.idTpv;

    if (this.idTpv) {
      this.idTpvData = this.idTpv;
    }

    if (this.idSector) {
      this.idSectorData = this.idSectorData;
    }

  },

  watch: {
    listElmExtra: {
      deep: true,
      handler(act, cur) {
        this.listExtraElement = act;
        this.idRepartidorData = act;
      },
    },
    idBusiness() {
      //Carga inicial está para que sólo se ejecute cuando cargue el informe por primera vez
      if (this.idBusiness != 0 && !this.cargaInicial) {
        this.cargaInicial = true;
        this.idSectorData = this.idSector;
        this.idBusinessData = this.idBusiness;
        this.cambioBusiness();
      }
    },
  },
  methods: {
    
    emitirConsulta() {
      if (this.conBuscador) {
        if (isNaN(parseInt(this.idExtraElement))) {
          this.idExtraElement = ""
          return;
        }
        this.$parent.cambiarExtra(this.idExtraElement);
      }
      /**------------------------------------------------ */
      if (this.conBuscadorRepartidor) {
        const repartidorSeleccionado = this.nombresRepartidores.find(worker => worker.id === this.idRepartidorData);
        const nombreRepartidor = repartidorSeleccionado ? repartidorSeleccionado.name : '';
        this.$emit('repartidorConsultado', { id: this.idRepartidorData, nombre: nombreRepartidor });
      }
      /**------------------------------------------------*/
      if (this.conFiltrarPorFecha) {
        this.$parent.emitirConsulta(this.filtrarPorFecha);
      } else if (this.busquedaPorHoras) {
        this.cambioHorasBusqueda();
        this.$parent.emitirConsulta();
      } else {
        this.$parent.emitirConsulta();
      }
      this.$store.dispatch("setDateTo", moment(this.dateto).format());
      this.$store.dispatch("setDateFrom", moment(this.datefrom).format());
    },

    cambioTpv() {
      this.idExtraElement = "";
      if (this.conFiltrarPorFecha) {
        this.$parent.cambioTpv(this.idTpvData);
      } else {
        this.$parent.cambioTpv(this.idTpvData, this.filtrarPorFecha);
      }
    },

    cambioHora() {
      this.$parent.cambioHora(this.dates);
    },
    cambioBuscarPorHoras() {
      this.$parent.cambioBuscarPorHoras(this.busquedaPorHoras);
    },
    cambioHorasBusqueda() {
      this.$parent.cambioHorasBusqueda(this.hoursdesde, this.hourshasta);
    },
    search(query) {
      this.idExtraElement = query;
      //this.listExtraElement = this.$parent.searchCabecera(query)
      this.$parent.searchCabecera(query);
      if (query) {
        this.filteredWorkers = this.nombresRepartidores.filter(worker =>
        worker.workerName
        );
      } else {
        this.filteredWorkers = this.listElmExtra;
      }
    },
    cambioSector() {

      this.$parent.loading = Loading.service({ text: "Cargando..." });
      let sectorData = this.idSectorData;

      this.listExtraElement = [];
      this.idRepartidorData = [];
      this.idExtraElement = "";
      this.listBusinessData = [];

      if (sectorData != 0) {
        let config = {
          params: {
            jwt: this.$store.getters.jwt,
          },
          headers: { 'Authorization': "Bearer " + this.$store.getters.jwt }
        };

        var params = {
          idBusiness: this.listSectores.find((sector) => sector.id == sectorData).idBusinessMaster,
          idSector: this.idSectorData,
          jwt: this.$store.getters.jwt,
        };

        let vm = this;
        this.axios.post(this.$store.getters.apiUrl + "general/getBusinessesBySector", params, config)
          .then(function (response) {

            if (response.data.response) {

              //Recojo todos los negocios de la carga inicial del sector seleccionado
              vm.listBusinessData = response.data.result;
              
              vm.idBusinessData = -1;
              vm.$parent.cambioSector(sectorData, vm.listBusinessData);

            } else {
              vm.$parent.loading.close();
            }

          }).catch(function (error) {
            console.log(error);
          })
      } else {
        const sector = this.listSectores.find(sector => sector.id == this.idSectorData);
        this.listBusinessData = sector.negocios;
        this.$parent.cambioSector(sectorData, this.listBusinessData);
      }
    },
    cambioCompany() {

      this.$parent.loading = Loading.service({ text: "Cargando..." });

      let companyData = this.idCompanyData;
      this.listBusinessData = [];

      var config = {
        params: {
          jwt: this.$store.getters.jwt,
          idCompany: this.idCompany,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      this.axios
        .get(this.$store.getters.apiUrl + "general/getBusinessesByCompany", config)
        .then(function (response) {

          vm.listBusinessData = response.data.result;
          vm.idBusinessData = -1;
          vm.$parent.cambioCompany(companyData, vm.listBusinessData);

        })
        .catch(function (error) {
          console.log(error);
        });
    },
    cambioBusiness() {
      let businessData = this.idBusinessData;
      //this.$parent.cambioBusiness(this.idBusinessData);
      this.listExtraElement = []
      this.idRepartidorData = []
      this.idExtraElement = "";
      this.listTpvData = [];
      // && this.sectores) {
      if (businessData == -1) {
        let businesses = [];
        this.listBusinesses.forEach(business => {

          if (business.id != -1) {
            businesses.push(parseInt(business.id));
          }

        });

        var config = {
          params: {
            idBusiness: businesses,
            jwt: this.$store.getters.jwt,
          },
          headers: { Authorization: "Bearer " + this.$store.getters.jwt },
        };

        let vm = this;
        this.axios
          .get(this.$store.getters.apiUrl + "general/getTpvsByListBusiness", config)
          .then(function (response) {
            if (response.data.response) {
              vm.listTpvData = response.data.result;

              if (vm.listTpvData.length > 0) {
                if (vm.sectores || businessData == -1) {
                  vm.idTpvData = -1;
                } else {
                  vm.idTpvData = vm.listTpvData[0].id;
                }
                vm.$parent.cambioBusiness(businessData, vm.listTpvData);
              } else {
                vm.idTpvData = -1;
              }
            }
          })
          .catch(function (error) {
            console.error(error);
          })
          .finally((_) => {
            vm.$parent.loading.close();
          });
      } else {
        var config = {
          params: {
            idBusiness: this.idBusinessData,
            jwt: this.$store.getters.jwt,
          },
          headers: { Authorization: "Bearer " + this.$store.getters.jwt },
        };

        let vm = this;
        this.axios
          .get(this.$store.getters.apiUrl + "general/getTpvsByBusiness", config)
          .then(function (response) {
            if (response.data.response) {
              vm.listTpvData = response.data.result;

              if (vm.listTpvData.length > 0) {
                if (vm.conTodos) {
                  vm.idTpvData = -1;
                } else {
                  vm.idTpvData = vm.listTpvData[0].id;
                }
                vm.$parent.cambioBusiness(businessData, vm.listTpvData);
              } else {

                if (vm.conTodos) {
                  vm.idTpvData = -1;
                } else {
                  vm.idTpvData = vm.listTpvData[0].id;
                }

              }
            }
          })
          .catch(function (error) {
            console.error(error);
          })
          .finally((_) => {
            vm.$parent.loading.close();
          });
      }
    },
  },
};
</script>
<style>
.theme-numier .vdatetime-calendar__month {
  height: 344.062px !important;
}

.theme-numier .vdatetime-year-picker__list,
.theme-numier .vdatetime-month-picker__list {
  height: 392.062px !important;
}
</style>
<style scoped>
a li {
  color: #111;
}

.card {
  padding: 20px;
}

.div-export {
  margin-bottom: 10px;
}

.econtainer div {
  padding-right: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/CabeceraInformes/CabeceraInformes.vue